import {
  FETCH_ADD_DOCUMENTS_REQUEST,
  FETCH_ADD_DOCUMENTS_SUCCESS,
  FETCH_ADD_DOCUMENTS_FALUIRE,
} from './addDocumentsTypes'

const initialState = {
  loading: false,
  addDocumentsInfo: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_ADD_DOCUMENTS_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_ADD_DOCUMENTS_SUCCESS : return {
      ...state,
      addDocumentsInfo: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_ADD_DOCUMENTS_FALUIRE : return {
      ...state,
      loading: false,
      addDocumentsInfo: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
